<i18n src="../../locales/lang.json"></i18n>

<template>

  <div class="container-fluid p-3">
    <div class="row mt-0" v-if="locationId === -1">
      <div class="col custom-form-main-label">
        {{ $store.translate('add_location')}}
      </div>
    </div>
    <div class="row mt-0" v-if="locationId >-1">
      <div class="col custom-form-main-label">
        {{$t('update_location')}} <a href="#" @click="getQRCodeUrl"><i class="icon-qrcode"></i></a>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="createLocationForm">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{ $store.translate('location_name')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="locname" type="text" id="txtlocname" v-bind:placeholder="$store.translate('location_name')" maxlength="200" name="locname" class="form-control" />
            </div>
          </div>
          <div class="row form-group mt-3">
            <div class="col-lg-12">
              <location-autocomplete ref="autocompleteLocation" @text_changed="adressChanged" @changed="adressChanged"></location-autocomplete>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('link_location_organisations')}} <info-note v-bind:text="$t('optionally_connect_a_location_to_organisation_message')"></info-note>
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <select class="form-control" v-bind:id="'select_assigned_Organisation_' +  getId()">
                <option value="-1" style="">{{$t('select_organisation')}}</option>
                <option v-for="Organisation in Organisations" v-bind:value="Organisation.Organisationid">
                  {{ Organisation.Organization }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button @click="savelocation" type="submit" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>

  </div>

</template>

<script>
  import LocationAutoComplete from '../location/location-autocomplete.vue'
  import InfoNote from '../notes/info-note.vue'

  let message = "";
  let Organisations = [];
  var OrganisationId = -1;
  export default {
    name: "add-location",
    components: {
      LocationAutoComplete,
      InfoNote
    },
    props: {
      locationId: {
        type: Number,
        default: -1
      },
      siteid: {
        type: Number,
        default: -1
      },
      locationOrganisationId: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        message: "",
        locname: "",
        Organisations: [],
        OrganisationId,
        qrcodeurl: "",
        lat: '',
        lng: '',
        adress: ''
      };
    },
    methods: {
      clearFields() {
        this.locname = '';
        $("#select_assigned_Organisation_" + this.getId()).val(-1);
        $("#select_assigned_Organisation_" + this.getId()).trigger('change');
        this.lat = '';
        this.lng = '';
        //$("#longitude").val('');
        //$("#latitude").val('');
        $("#AutoCompletedLocation").val('');
      },
      adressChanged(adress, lat, lng) {
        this.adress = adress;
        this.lat = lat;
        this.lng = lng;
      },
      fetchReloadData() {
        this.locationId = -1;
        this.getOrganisations();
      },
      getId() {
        return this._uid;
      },
      async savelocation() {
        if (!$('#createLocationForm').valid())
          return false;
        this.OrganisationId = $('#select_assigned_Organisation_' + this.getId()).val();

        //var long = $("#longitude").val();
        //var lat = $("#latitude").val();
        //var address = $("#AutoCompletedLocation").val();
        var request = {
          LocationId: this.locationId, LocationName: this.locname, OrganisationId: this.OrganisationId,
          LocationOrganisationid: this.locationOrganisationId, Longitude: this.lng, Lattitude: this.lat, Address: this.adress
        };

        try {
          var response = await this.$http.post(
            '/api/Locations/v1',
            request
          ).then(async response => {
            this.OrganisationId = "";
            this.clearFields();
            vm.$root.$emit('refreshview');
          })//, response => {
          //    //error
          //    console.log(response);
          //    alert(response.response.status);
          //  if (response.status == 401) {
          //    console.log('hello')
          //    console.log(response)
          //  }
          //})

        } catch (err) {
          //alert(err);
          //handleClientException(err.response.status === 401);
        }
      },
      async getOrganisations() {
        try {
          this.Organisations = [];
          this.$http.get('/api/Organizations/v1').then(async response => {
            this.Organisations = response.data;
            if (this.Organisations !== null && this.Organisations.length > 0) {
              this.Organisations = this.Organisations.sort(function (a, b) {
                var x = a.Organization.toLowerCase();
                var y = b.Organization.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            $('#select_assigned_Organisation_' + this.getId()).select2();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async getLocation(locationId) {
        try {
          if (locationId > 0) {
            this.$http.get('/api/Locations/v1/Organisation?id=' + locationId + '&cusLocId=' + this.locationOrganisationId).then(async response => {
              var location = response.data;
              this.locname = location.LocationName;
              //alert(this.locationOrganisationId);
              //$("#select_assigned_Organisation_" + this.getId()).select2().select2('val', this.locationOrganisationId);
              if (location.OrganisationId > 0) {
                $("#select_assigned_Organisation_" + this.getId()).val(location.OrganisationId);
                $("#select_assigned_Organisation_" + this.getId()).trigger('change');
              } else {
                $("#select_assigned_Organisation_" + this.getId()).val(-1);
                $("#select_assigned_Organisation_" + this.getId()).trigger('change');
              }
              this.lat = location.Lattitude;
              this.lng = location.Longitude;
              this.adress = location.Address;
              //$("#longitude").val(location.Longitude);
              //$("#latitude").val(location.Lattitude);
              //$("#AutoCompletedLocation").val(location.Address);
              this.$refs.autocompleteLocation.setValue(location.Address, location.Lattitude, location.Longitude);
            });
          }
        } catch (err) {
          alert('some error:' + err)
        }
      },

      getQRCodeUrl() {
        try {
          var tmpProcedureid = "";
          var url = '/api/Procedures/v1/GetQRCodeUrl?procedureId=0&locationId=' + this.locationId + '&teamId=0&projectId=0&organisationId=0&shiftId=0&username=0&procedureScheduleId=0';
          this.$http.get(url).then(response => {
            this.qrcodeurl = response.data.Url;
            this.printImage();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      /**
       * https://stackoverflow.com/questions/2909033/using-javascript-to-print-images
     * Prints an image by temporarily opening a popup
     * @param {string} src - image source to load
     * @returns {void}
     */
      printImage() {

        var win = window.open('about:blank', "_new");
        win.document.open();
        //'   <body onload="window.print()" onafterprint="window.close()">',
        win.document.write([
          '<html>',
          '   <head>',
          '   <link href="/assets/css/all.css" rel="stylesheet" type="text/css">',
          '   </head>',
          '   <body>',
          '   <div class="container-fluid" style="max-width:270px">',
          '   <div class="row col-12">',
          '   <div class="card">',
          '       <h1 contenteditable="true" class="pt-3 pb-3 mb-0 text-center">' + this.locname + '</h1><div style="background-color:white;padding:0px;padding-top:0px;text-align:center"><img width="190" height="190" src="' + this.qrsource + '"/></div>',
          '       <div class="card-body" contenteditable="true">Scan the code, login and view tasks on this location!</div>',
          '   </div>',
          '   </div>',
          '   </div>',
          '   </body>',
          '</html>'
        ].join(''));
        win.document.close();
      },

    },
    watch: {
      locationId: function (newVal, oldVal) {
        //if (newVal > 0) {
        //  this.getLocation(newVal);
        //} else {
        //  this.locname = '';
        //}
        this.locname = '';
        this.getLocation(newVal);
      },
      locationOrganisationId: function (newVal, oldVal) {
        if (newVal > 0) {
          //$("#select_assigned_Organisation_" + this.getId()).val(newVal);
          //$("#select_assigned_Organisation_" + this.getId()).trigger('change');
        }
      },
    },
    mounted() {
      //this.initValidation();

      _componentValidation('#createLocationForm');
      if (this.locationId > 0) {
        this.getLocation(this.locationId);
      }
      //this.getOrganisations();

    },
    computed: {
      qrsource: {
        get: function () {
          return apiUrl + '/api/Procedures/v1/GetQRCode?procedureId=0&locationId=' + this.locationId + '&teamId=0&projectId=0&organisationId=0&shiftId=0&username=' + this.assignedUser + '&procedureScheduleId=0&siteid=' + this.siteid;
        },
      }
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/location/add-location.vue